// Couleurs orange définies dans tailwind.config.js (sous yellow)
export const ORANGE_COLORS = {
  50: '#fff6eb',   // orange-50
  100: '#ffe4c1',  // orange-100
  500: '#ff9600',  // orange-500
  600: '#d77a1e',  // orange-600
};

